import script from "./MainInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MainInfo.vue?vue&type=script&setup=true&lang=js"

import "./MainInfo.vue?vue&type=style&index=0&id=57494b3b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57494b3b"]])

export default __exports__